export default __webpack_public_path__ + "static/media/deliverto.aa804db5.svg";